import Icon24 from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'

import { HeaderButton } from '../Banners/HeaderButton/HeaderButton'
import { TRANSLATION } from './constants'
import { useCoachBanner } from './hooks/useCoachBanner'

export const BookCoachButton = () => {
  const { i18n } = useI18n()
  const { handleBookCoachButton } = useCoachBanner()

  return (
    <HeaderButton
      type="career_coaching"
      onClick={handleBookCoachButton}
      text={i18n.t(`${TRANSLATION}.actions.book_coach`)}
      icon={<Icon24.Conversation />}
      tooltip={i18n.t(`${TRANSLATION}.tooltip`)}
    />
  )
}
